import { render, staticRenderFns } from "./AppointmentCard.vue?vue&type=template&id=1ac19310&scoped=true"
import script from "./AppointmentCard.vue?vue&type=script&lang=js"
export * from "./AppointmentCard.vue?vue&type=script&lang=js"
import style0 from "./AppointmentCard.vue?vue&type=style&index=0&id=1ac19310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac19310",
  null
  
)

export default component.exports